import { MatDialogRef } from '@angular/material/dialog';
import { AllocationViewProfile } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';
import { AllocationViewFiltersModel } from '../../allocation-view/models';

export class AllocationViewProfileItemLoad {
  public static readonly type = '[AllocationViewProfileItem] Load';
  constructor(public id: number) {}
}

export class AllocationViewFilterItemLoad {
  public static readonly type = '[AllocationViewFilterItem] Load';
  constructor(public id: number) {}
}

export class AllocationViewProfileItemLoadDefault {
  public static readonly type = '[AllocationViewProfileItem] Load Default';
}

export class AllocationViewProfileItemSaveWithFilter {
  public static readonly type = '[AllocationViewProfileItem] Save With Filter';
  constructor(public filters: AllocationViewFiltersModel, public profile: AllocationViewProfile) {}
}

export class AllocationViewProfileItemSave {
  public static readonly type = '[AllocationViewProfileItem] Save';

  constructor(public profile: AllocationViewProfile) {}
}

export class AllocationViewProfileItemDelete {
  public static readonly type = '[AllocationViewProfileItem] Delete';

  constructor(public id: number, public dialogRef: MatDialogRef<ConfirmationDialogAfterClosedModel>) {}
}

export class AllocationViewProfileItemInitialState {
  public static readonly type = '[AllocationViewProfileItem] Set Initial State';
}

export class AllocationViewProfileItemDriverViewLoad {
  public static readonly type = '[AllocationViewProfileItem] Driver View Load';
  constructor(public id: number) {}
}
